import type { AuthProviderProps } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';

// Where this app lives (used to build redirect URIs). Defaults to the current origin,
// so it works for localhost:3003 in dev and the deployed origin in prod without changes.
const appOrigin = import.meta.env.VITE_APP_ORIGIN || window.location.origin;

// The LeTech ID server (AuthHub). Override per-environment at build time via VITE_OIDC_AUTHORITY.
const authority = import.meta.env.VITE_OIDC_AUTHORITY || 'https://id.letech.solutions';

export const oidcConfig: AuthProviderProps = {
  authority,
  client_id: import.meta.env.VITE_OIDC_CLIENT_ID || 'recipevault',
  redirect_uri: `${appOrigin}/callback`,
  post_logout_redirect_uri: appOrigin,
  silent_redirect_uri: `${appOrigin}/silent-renew`,
  response_type: 'code',
  scope: 'openid profile email api offline_access',
  // Keep tokens across reloads; refresh silently before expiry.
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  // Note: post-sign-in redirect is handled by the AuthCallback component via react-router
  // (history.replaceState here wouldn't update the router, leaving /callback mounted).
};
